import { ItemClass } from './types';
export function isParent(item) {
    return [
        ItemClass.Group,
        ItemClass.Mask,
        ItemClass.CompoundPath,
        ItemClass.Canvas,
    ].includes(item.className);
}
export function isFillable(item) {
    return [
        ItemClass.Group,
        ItemClass.Mask,
        ItemClass.Raster,
        ItemClass.Shape,
        ItemClass.Path,
        ItemClass.CompoundPath,
    ].includes(item.className);
}
export function isStrokable(item) {
    return [
        ItemClass.Group,
        ItemClass.Mask,
        ItemClass.Raster,
        ItemClass.Shape,
        ItemClass.Path,
        ItemClass.CompoundPath,
    ].includes(item.className);
}
export function isOfType(item, type) {
    return item.className === ItemClass[type];
}
export function filterByType(items) {
    var itemClasses = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        itemClasses[_i - 1] = arguments[_i];
    }
    return items.filter(function (item) {
        return itemClasses.some(function (itemClass) { return isOfType(item, itemClass); });
    });
}
